import React from "react";
import { useTranslation } from "react-i18next";
import Input from "components/Input";

export interface BrowzwearCredentials {
  apiKey: string;
  apiSecret: string;
  storeName: string;
  email: string;
}

interface BrowzwearAPIFormProps {
  credentials: BrowzwearCredentials;
  setCredentials: React.Dispatch<React.SetStateAction<BrowzwearCredentials>>;
  className?: string;
}

const BrowzwearAPIForm: React.FC<BrowzwearAPIFormProps> = ({ credentials, setCredentials, className }) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <span className="text-bodySm text-white">{t("common:integrations.browzwear_form.intro")}</span>

      <div className="flex flex-col gap-2.5 mt-4">
        <span className="text-h7 text-white">{t("common:integrations.browzwear_form.email")}</span>
        <Input containerClassName="!bg-black-200" value={credentials.email} onChange={(e: any) => setCredentials((prev) => ({ ...prev, email: e.target.value }))} />
        {/* This field is looked up in STYLEZONE, not here: `/connect` resolves the owner id with
            `GET /users/email/<it>` and the connection is refused without one. It is pre-filled from
            the Refabric login purely because the two are often the same address — when they are not,
            the lookup 404s and connecting fails with valid API credentials, which is precisely what
            happened on the Polytropon account (REF-6498). Say which email it wants. */}
        <span className="text-bodyXs text-grey -mt-1">{t("common:integrations.browzwear_form.email_hint")}</span>
      </div>
      <div className="flex flex-col gap-2.5 mt-3">
        <span className="text-h7 text-white">{t("common:integrations.browzwear_form.api_key")}</span>
        <Input containerClassName="!bg-black-200" value={credentials.apiKey} onChange={(e: any) => setCredentials((prev) => ({ ...prev, apiKey: e.target.value }))} />
      </div>
      <div className="flex flex-col gap-2.5 mt-3">
        <span className="text-h7 text-white">{t("common:integrations.browzwear_form.api_secret")}</span>
        <Input containerClassName="!bg-black-200" value={credentials.apiSecret} onChange={(e: any) => setCredentials((prev) => ({ ...prev, apiSecret: e.target.value }))} />
      </div>
      <div className="flex flex-col gap-2.5 mt-3">
        <span className="text-h7 text-white">{t("common:integrations.browzwear_form.store_name")}</span>
        <Input containerClassName="!bg-black-200" value={credentials.storeName} onChange={(e: any) => setCredentials((prev) => ({ ...prev, storeName: e.target.value }))} />
      </div>
    </div>
  );
};

export default BrowzwearAPIForm;
